module.exports = __webpack_public_path__ + "img/IMG_20190508_160532.5be4c25f.jpg";